import Enumerator from './Enumerator';

export const importantOptions = [
  'none',
  'important',
  'not_important',
  'most_important',
  'somewhat_important',
  'least_important',
  'do_not_want'
];

export class ImportantOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case 'r1':
        correctOption = 'important';
        break;
      case 'r2':
        correctOption = 'not_important';
        break;
      case 'i1':
        correctOption = 'most_important';
        break;
      case 'i2':
        correctOption = 'somewhat_important';
        break;
      case 'i3':
        correctOption = 'least_important';
        break;
      case 'r3':
        correctOption = 'do_not_want';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ImportantOption.initEnum(importantOptions);

export default {
  importantOptions,
  ImportantOption
};
